import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
//import 'vuetify/src/stylus/app.styl'
import 'vuetify/src/styles/main.sass'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md' || 'fa'
  },
  theme: {
    options: {
      customProperties: true,
    },
    dark: false,
    themes: {
      light: {
        primary: '#61B65C',
        secondary: '#297253',
        accent: '#49BAD3',
        error: '#FF5A60',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        primary: '#61B65C',
        secondary: '#297253',
        accent: '#49BAD3',
        error: '#FF5A60',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  }
})